var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/sensitive-button.tsx";
import React from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { changeComposeSensitivity } from 'soapbox/actions/compose';
import { FormGroup, Checkbox } from 'soapbox/components/ui';
import { useAppSelector, useAppDispatch } from 'soapbox/hooks';
const messages = defineMessages({
  marked: {
    "id": "compose_form.sensitive.marked",
    "defaultMessage": "Media is marked as sensitive"
  },
  unmarked: {
    "id": "compose_form.sensitive.unmarked",
    "defaultMessage": "Media is not marked as sensitive"
  }
});

/** Button to mark own media as sensitive. */
const SensitiveButton = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const active = useAppSelector(state => state.compose.sensitive === true);
  const disabled = useAppSelector(state => state.compose.spoiler === true);
  const onClick = () => {
    dispatch(changeComposeSensitivity());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-2.5 py-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "compose_form.sensitive.hide",
      defaultMessage: "Mark media as sensitive",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 20
      }
    }),
    labelTitle: intl.formatMessage(active ? messages.marked : messages.unmarked),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "mark-sensitive",
    checked: active,
    onChange: onClick,
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  })));
};
export default SensitiveButton;